<template>
  <div class="h-auto bg-white w-full pt-6 pb-8 pl-8 pr-8">
    <div class="">
      <div class="all">
        <div class="w-full flex text-6b text-c16 font-c7 text-left mb-6 text-titre">
          <div class="w-1/4">
            Nom
          </div>
          <div class="w-1/6 ml-4">
            Téléphone
          </div>
          <div class="w-1/4 ml-4">
            Email
          </div>
          <div class="w-1/5 ml-4">
            Organisation
          </div>
          <div class="w-1/6 ml-4 text-center">
            Droits
          </div>
          <div class="w-96 text-center" />
          <!-- <div class="w-60 text-center" /> -->
        </div>

        <div class="diviser" />

        <div
          v-if="charge"
          class="flex justify-center mt-16"
        >
          <easy-spinner
            type="dots"
            size="70"
          />
        </div>

        <div
          class="text-center mt-10"
          v-if="tracker.length === 0 && !charge"
        >
          Aucun administrateur pour le moment
        </div>

        <div
          v-for="(item, index) in tracker"
          :key="index"
          class="mt-5"
        >
          <div
            v-if="index > 0"
            class="diviser mt-5"
          />
          <div>
            <liste
              :item="item"
              @delete="openDeletePopup"
              @open-view="openLimitPopup"
              @toggle-status="openTogglePopup"
            />
          </div>
        </div>

        <!-- Popup de suppression -->
        <delete-popup
          v-if="showDeletePopup"
          :show-popup="showDeletePopup"
          :selected-id="selectedId"
          @closeDeletePopup="closeDeletePopup"
          @confirm-delete="confirmDelete"
        />
        <limit-view-popup
          v-if="showLimitPopup && selectedForLimit"
          :item="selectedForLimit"
          @close="closeLimitPopup"
          @confirm="confirmLimit"
        />
        <toggle-status-popup
          v-if="showTogglePopup && selectedForToggle"
          :item="selectedForToggle"
          @close="closeTogglePopup"
          @confirm="confirmToggle"
        />
      </div>
    </div>
  </div>
</template>

<script>
import arrow from '../../../assets/icons/arrow.svg'
import agenda from '../../../assets/icons/agenda.svg'
import down from '../../../assets/icons/down.svg'
import prev from '../../../assets/icons/prev.svg'
import next from '../../../assets/icons/next.svg'
import liste from './liste'
import deletePopup from './deleteAcces.vue'
import limitViewPopup from './limitViewPopup.vue'
import toggleStatusPopup from './toggleStatusPopup.vue'
import apiroutes from '../../../router/api-routes'
import http from '../../../plugins/https'
import { deleteAdmin, limitateView, desactiveAdmin, reactiveAdmin } from "../allFunctions"

export default {
  name: "Index",
  components: {
    liste,
    deletePopup,
    limitViewPopup,
    toggleStatusPopup
  },

  props: {
    search: {
      type: String,
      default: null
    },
    filtrage: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      icons: {
        arrow,
        agenda,
        down,
        prev,
        next
      },
      client: [],
      charge: true,
      page: 1,
      limite: 30,
      total: 0,
      totalPage: 0,
      devisPaginate: [],
      temoin: null,
      dataClient: [],
      showDeletePopup: false,
      // selectedItem: null,
      selectedId: null
      ,
      showLimitPopup: false,
      selectedForLimit: null,
      showTogglePopup: false,
      selectedForToggle: null
    }
  },

  computed: {
    tracker: function() {
      let retour = this.dataClient

      if (this.search !== null && this.search !== '') {
        const type = this.search.toLowerCase()
        retour = retour.filter((item) => {
          if (((item.fullName).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()).indexOf(type.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')) !== -1 ||
              ((item.body.lastName).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()).indexOf(type.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')) !== -1 ||
              (item.categorie.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()).indexOf(type.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')) !== -1) {
            return item
          }
        })
      }

      if (this.filtrage) {
        if (this.filtrage === 'TOUT') {
          retour = this.dataClient
        } else {
          retour = retour.filter((item) => {
            if (((item.categorie).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()).indexOf(this.filtrage.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')) !== -1) {
              return item
            }
          })
        }
      }

      return retour
    }
  },

  created() {
    this.getAllAdmin()
  },

  methods: {
    prev() {
      if (this.page > 1) {
        this.page = this.page - 1
        this.getAllAdmin()
      }
    },

    next() {
      if (this.totalPage > this.page) {
        this.page = this.page + 1
        this.getAllAdmin()
      }
    },

    activeCharge(value) {
      this.charge = value
    },

    openDeletePopup(item) {
      console.log('Item reçu dans openDeletePopup:', item)
      // this.selectedItem = item
      this.selectedId = item.info?.id
      console.log('selectedId défini:', this.selectedId)
      this.showDeletePopup = true
    },

    openLimitPopup(item) {
      this.selectedForLimit = item
      this.showLimitPopup = true
    },

    closeLimitPopup() {
      this.showLimitPopup = false
      this.selectedForLimit = null
    },

    async confirmLimit(payload) {
      const id = payload?.id
      const isViewer = payload?.isViewer
      console.log('ID reçu pour mise à jour des droits:', id, 'isViewer:', isViewer)

      if (!id) {
        this.$toast.error('Aucun administrateur sélectionné')
        return
      }

      this.charge = true
      try {
        const response = await limitateView(id, { isViewer })
        console.log('Réponse limitateView:', response)

        // Mettre à jour le store avec le nouveau statut isViewer
        const loggedInUser = this.$store.getters.trackUser
        this.$store.dispatch('saveUser', {
          ...loggedInUser,
          user: { ...loggedInUser.user, isViewer }
        })

        this.charge = false
        this.$toast.success('Droits mis à jour avec succès')
        this.closeLimitPopup()
        this.getAllAdmin()
      } catch (error) {
        console.log('Erreur lors de la mise à jour des droits:', error)
        this.charge = false
        this.$toast.error('Une erreur est survenue lors de la mise à jour des droits')
      }
    },

    closeDeletePopup() {
      this.showDeletePopup = false

    },

    async confirmDelete(id) {
      console.log('ID reçu pour suppression:', id)
      
      if (!id) {
        this.$toast.error('Aucun administrateur sélectionné')
        return
      }

      this.charge = true
      // const data = {
      //   id: id
      // }
      
      try {
        const response = await deleteAdmin(id)
        console.log('Réponse de suppression:', response)
        this.charge = false
        this.$toast.success('Administrateur supprimé avec succès')
        this.closeDeletePopup()
        // Recharger la liste des administrateurs
        this.getAllAdmin()
      } catch (error) {
        console.log('Erreur lors de la suppression:', error)
        this.charge = false
        this.$toast.error('Une erreur est survenue lors de la suppression')
      }
    },

    openTogglePopup(item) {
      this.selectedForToggle = item
      this.showTogglePopup = true
    },

    closeTogglePopup() {
      this.showTogglePopup = false
      this.selectedForToggle = null
    },

    async confirmToggle(payload) {
      const { item, isActive } = payload
      const id = item?.info?.id

      if (!id) {
        this.$toast.error('Aucun administrateur sélectionné')
        return
      }

      this.charge = true
      try {
        if (isActive) {
          await desactiveAdmin(id)
          this.$toast.success('Administrateur désactivé avec succès')
        } else {
          await reactiveAdmin(id)
          this.$toast.success('Administrateur activé avec succès')
        }
        this.closeTogglePopup()
        this.getAllAdmin()
      } catch (error) {
        console.log('Erreur toggle statut:', error)
        this.$toast.error('Une erreur est survenue lors du changement de statut')
      } finally {
        this.charge = false
      }
    },

    getAllAdmin() {
      this.charge = true
      http.post(apiroutes.baseURL + apiroutes.allAdmin, {
        userType: 'ADMIN'
      })
      .then(response => {
        this.dataClient = response
        this.getAllSfd()
      })
      .catch(error => {
        this.charge = false
        console.log(error)
      })
    },

    getAllSfd() {
      http.post(apiroutes.baseURL + apiroutes.allAdmin, {
        userType: 'SFDADMIN'
      })
      .then(response => {
        console.log("Réponse SFDADMIN :", response)
        for (let r in response) {
          this.dataClient.push(response[r])
        }
        const selectedId = this.dataClient.map(item => item.info.id)
        console.log("Ids récupérés :", selectedId)
        this.charge = false
      })
      .catch(error => {
        this.charge = false
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.svg-icon{
  fill: transparent;
}
.filtr{
  background: rgba(242, 245, 249, 0.5);
  border: 0.5px solid #C4C4C4;
  box-sizing: border-box;
  border-radius: 5px;
  height: 36.39px;
}
.compFiltre{
  width: auto;
  min-width: 9.1%;
}
.diviser {
  height: 0.5px;
  background-color: #DDDDDD;
}
</style>